import MatterportEditorMain from './components/MatterportEditorMain'
function App() {
  return <MatterportEditorMain />
}

export default App
